import { render, staticRenderFns } from "./SearchResultsArticle.vue?vue&type=template&id=204c41ad&scoped=true&"
import script from "./SearchResultsArticle.vue?vue&type=script&lang=js&"
export * from "./SearchResultsArticle.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsArticle.vue?vue&type=style&index=0&id=204c41ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204c41ad",
  null
  
)

export default component.exports